import { CellarInvitation } from '../types';

interface PendingInvitationsProps {
  invitations: CellarInvitation[];
  onAccept: (invitation: CellarInvitation) => void;
  onDecline: (invitation: CellarInvitation) => void;
  onClose: () => void;
}

export function PendingInvitations({ invitations, onAccept, onDecline, onClose }: PendingInvitationsProps) {
  return (
    <div className="modal-overlay" onClick={onClose}>
      <div 
        className="ios-sheet w-full"
        onClick={e => e.stopPropagation()}
      >
        <div className="ios-sheet-handle" />

        {/* Header */}
        <div style={{ 
          padding: '0 20px 16px',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center'
        }}>
          <div style={{ width: '50px' }} />
          <h2 className="wine-title" style={{ 
            fontSize: '18px', 
            margin: 0,
            color: 'var(--color-text)'
          }}>
            Pending Invitations
          </h2>
          <button
            onClick={onClose}
            style={{
              background: 'none',
              border: 'none',
              color: 'var(--color-wine)',
              fontSize: '16px',
              cursor: 'pointer'
            }}
          >
            Done
          </button>
        </div>

        <div style={{ padding: '0 16px 20px' }}>
          {invitations.length === 0 ? (
            <div style={{ textAlign: 'center', padding: '32px', color: 'var(--color-text-muted)' }}>
              No pending invitations
            </div>
          ) : (
            <div className="ios-card" style={{ overflow: 'hidden' }}>
              {invitations.map((invitation, index) => (
                <div 
                  key={invitation.id} 
                  style={{ 
                    padding: '16px',
                    borderBottom: index < invitations.length - 1 ? '1px solid var(--color-border)' : 'none'
                  }}
                >
                  <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '12px' }}>
                    <span style={{ fontSize: '24px' }}>🍷</span>
                    <div>
                      <p className="wine-title" style={{ 
                        fontSize: '17px', 
                        color: 'var(--color-text)',
                        marginBottom: '2px'
                      }}>
                        {invitation.cellars?.name || 'Unknown Cellar'}
                      </p>
                      <p style={{ fontSize: '13px', color: 'var(--color-text-muted)' }}>
                        You've been invited to join this cellar
                      </p>
                    </div>
                  </div>
                  <div style={{ display: 'flex', gap: '8px' }}>
                    <button
                      onClick={() => onAccept(invitation)}
                      className="ios-btn"
                      style={{ 
                        flex: 1, 
                        background: 'var(--color-success)', 
                        color: 'white',
                        padding: '10px'
                      }}
                    >
                      Accept
                    </button>
                    <button
                      onClick={() => onDecline(invitation)}
                      className="ios-btn"
                      style={{ 
                        flex: 1, 
                        background: '#fee2e2', 
                        color: '#991b1b',
                        padding: '10px'
                      }}
                    >
                      Decline
                    </button>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
